module.exports = __webpack_public_path__ + "img/02.5c90ff09.png";